import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const LeadForm = () => {
  useEffect(() => {
    // Load the Fillout embed script
    const script = document.createElement('script');
    script.src = "https://server.fillout.com/embed/v1/";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script safely if component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="lead-form" className="py-32 bg-spanish-ivory">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div 
          className="bg-spanish-ivory p-8 md:p-12 rounded-xl shadow-2xl border border-olive-sage/30 relative overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="absolute top-0 left-0 w-full h-1.5 bg-antique-gold"></div>
          
          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl text-mission-green mb-6 uppercase tracking-wider">
              Check December Availability
            </h2>
            <div className="h-0.5 w-16 bg-antique-gold mx-auto mb-6"></div>
            <p className="text-mission-green/70 text-lg max-w-2xl mx-auto">
              Our corporate events team will reach out to discuss dates, pricing, and scheduling a private tour of the estate.
            </p>
          </div>

          <div className="min-h-[500px] w-full rounded-lg overflow-hidden border border-olive-sage/10 bg-white/50">
            {/* Fillout Embed Container - Uses React inline styles and boolean attributes */}
            <div 
              style={{ width: '100%', height: '500px' }} 
              data-fillout-id="pLzHt9iFRbus" 
              data-fillout-embed-type="standard" 
              data-fillout-inherit-parameters 
              data-fillout-dynamic-resize
            ></div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-olive-sage font-sans uppercase tracking-[0.2em]">
              Secure your date for the 2024 Holiday Season
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LeadForm;